import { mapMutations } from "vuex";
import router from "@/router/index";

export default {
  methods: {
    selectDate({ year, month, date }) {
      this.toggleCalendar();
      this.updateDate({ year, month, date });
      router.push({ name: "NotePage", params: { yearParam: year, monthParam: month, dateParam: date } });
    },
    ...mapMutations([
      "updateMonthYear",
      "updateDate",
      "toggleCalendar",
    ]),
  },
};



// WEBPACK FOOTER //
// ./src/mixins/calendar.js